export default "__VITE_ASSET__DjyDpnge__"